export const ADMIN_DISABLED_WARNING = 'Adminlere Uyari: Combo Aktif degil!';
